var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"user-avatar",style:({ height: `${_vm.size}px`, width: `${_vm.size}px` }),attrs:{"src":_vm.getAvatar(_vm.src),"alt":"avatar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }